<span [innerHTML]="typedText"></span>
<span class="cursor" [style.visibility]="showCursor ? 'visible' : 'hidden'"></span>